import * as React from "react";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import {PressableProps} from "../../../common/props/PresableProps";
import {FocusableProps} from "../../../common/props/FocusableProps";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";
import {Option} from "ts-option";
import SelectMerchant from "./SelectMerchant";
import {PlaceholderProps} from "../../../common/props/PlaceholderProps";
import {ClearableProps} from "../../../common/props/ClearableProps";

type Props = FormGroupProps<string> & FocusableProps & PressableProps & PlaceholderProps & ClearableProps;

/**
 * Merchant form view group.
 */
export default class MerchantFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectMerchant placeholder={this.props.placeholder}
								selectedId={this.props.field.value}
								onChanged={this.onChange}
								clearable={this.props.clearable}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed merchant.
	 * @param merchant
	 */
	onChange(merchant: Option<DictionaryItem>) {
		this.props.onChange(this.props.field.updateValue(merchant.map((m) => m.id)));
	}
}